import React from "react";

function phoneToTelHref(raw) {
  const d = raw.replace(/\D/g, "");
  if (d.length < 9) return `tel:${raw.replace(/\s/g, "")}`;
  let n = d;
  if (n.startsWith("385")) return `tel:+${n}`;
  if (n.startsWith("0")) return `tel:+385${n.slice(1)}`;
  return `tel:+${n}`;
}

/** HR IBAN je HR + 19 znamenki; unutra se mogu pojaviti podnizovi poput 09x pa ne smiju biti tel: link. */
function isRangeInsideHrIban(text, start, end) {
  const re = /HR\d{17,21}/g;
  let m;
  while ((m = re.exec(text)) !== null) {
    if (start >= m.index && end <= m.index + m[0].length) return true;
  }
  const spaced = /HR\d{2}(?:\s?\d{4}){4}\s?\d{1,4}/g;
  while ((m = spaced.exec(text)) !== null) {
    if (start >= m.index && end <= m.index + m[0].length) return true;
  }
  return false;
}

/**
 * Email i hrvatski mobilni brojevi u tekstu postaju klikabilni linkovi.
 * Ostatak teksta ostaje isti (uklj. \n za pre-wrap).
 */
export function linkifyContactText(text) {
  if (!text || typeof text !== "string") return text;

  const pattern =
    /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})|((?:\+385|0)\s*9[0-9](?:\s*\d){6,10})/g;

  const parts = [];
  let lastIndex = 0;
  let match;
  let key = 0;

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const full = match[0];
    if (match[1]) {
      parts.push(
        <a
          key={`lc-${key++}`}
          href={`mailto:${match[1]}`}
          className="tour-contact-link"
        >
          {full}
        </a>
      );
    } else {
      const phoneStart = match.index;
      const phoneEnd = match.index + full.length;
      if (isRangeInsideHrIban(text, phoneStart, phoneEnd)) {
        parts.push(full);
      } else {
        parts.push(
          <a
            key={`lc-${key++}`}
            href={phoneToTelHref(full)}
            className="tour-contact-link"
          >
            {full}
          </a>
        );
      }
    }
    lastIndex = match.index + full.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length ? parts : text;
}
